/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BeneficialOwnerPartnerRole,
  BusinessRelationTypeResponse,
  Currencies,
  EligibilityCheckResponse,
} from '../models/index';
import {
    BeneficialOwnerPartnerRoleFromJSON,
    BeneficialOwnerPartnerRoleToJSON,
    BusinessRelationTypeResponseFromJSON,
    BusinessRelationTypeResponseToJSON,
    CurrenciesFromJSON,
    CurrenciesToJSON,
    EligibilityCheckResponseFromJSON,
    EligibilityCheckResponseToJSON,
} from '../models/index';

export interface GetBeneficialOwnersToBrRequest {
    brUid: string;
}

export interface GetBrCurrenciesRequest {
    brUid: string;
}

export interface GetBrTypeRequest {
    brUid: string;
}

export interface IsBrEligibleRequest {
    brUid: string;
}

/**
 * 
 */
export class BrsApi extends runtime.BaseAPI {

    /**
     * Creates request options for getBeneficialOwnersToBr without sending the request
     */
    async getBeneficialOwnersToBrRequestOpts(requestParameters: GetBeneficialOwnersToBrRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getBeneficialOwnersToBr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/brs/{brUid}/beneficialOwners`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns partner-to-BR roles that represent beneficial ownership for the given BR: Beneficial Owner, Beneficial Owner Third Party (incl. 3rd party code), and Beneficiary. 
     * Get beneficial owners linked to the business relationship
     */
    async getBeneficialOwnersToBrRaw(requestParameters: GetBeneficialOwnersToBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BeneficialOwnerPartnerRole>>> {
        const requestOptions = await this.getBeneficialOwnersToBrRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BeneficialOwnerPartnerRoleFromJSON));
    }

    /**
     * Returns partner-to-BR roles that represent beneficial ownership for the given BR: Beneficial Owner, Beneficial Owner Third Party (incl. 3rd party code), and Beneficiary. 
     * Get beneficial owners linked to the business relationship
     */
    async getBeneficialOwnersToBr(requestParameters: GetBeneficialOwnersToBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BeneficialOwnerPartnerRole>> {
        const response = await this.getBeneficialOwnersToBrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getBrCurrencies without sending the request
     */
    async getBrCurrenciesRequestOpts(requestParameters: GetBrCurrenciesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getBrCurrencies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/brs/{brUid}/brCurrencies`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the reference currency for the given business relation
     * Get business relation reference currency
     */
    async getBrCurrenciesRaw(requestParameters: GetBrCurrenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Currencies>> {
        const requestOptions = await this.getBrCurrenciesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrenciesFromJSON(jsonValue));
    }

    /**
     * Returns the reference currency for the given business relation
     * Get business relation reference currency
     */
    async getBrCurrencies(requestParameters: GetBrCurrenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Currencies> {
        const response = await this.getBrCurrenciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getBrType without sending the request
     */
    async getBrTypeRequestOpts(requestParameters: GetBrTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling getBrType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/brs/{brUid}/type`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the business relation type for the given BR
     * Get business relation type
     */
    async getBrTypeRaw(requestParameters: GetBrTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessRelationTypeResponse>> {
        const requestOptions = await this.getBrTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessRelationTypeResponseFromJSON(jsonValue));
    }

    /**
     * Returns the business relation type for the given BR
     * Get business relation type
     */
    async getBrType(requestParameters: GetBrTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessRelationTypeResponse> {
        const response = await this.getBrTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for isBrEligible without sending the request
     */
    async isBrEligibleRequestOpts(requestParameters: IsBrEligibleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling isBrEligible().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/brs/{brUid}/isEligible`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the list of eligibility checks
     * Check if given business relation is eligible to access to a list of features
     */
    async isBrEligibleRaw(requestParameters: IsBrEligibleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EligibilityCheckResponse>> {
        const requestOptions = await this.isBrEligibleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EligibilityCheckResponseFromJSON(jsonValue));
    }

    /**
     * Returns the list of eligibility checks
     * Check if given business relation is eligible to access to a list of features
     */
    async isBrEligible(requestParameters: IsBrEligibleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EligibilityCheckResponse> {
        const response = await this.isBrEligibleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
